<script setup>
const {color} = defineProps({
  color: {
    type: String,
  },
})
</script>

<template>
  <g>
    <path
        d="M14.5 2H14C13.4477 2 13 2.44772 13 3V5.5C13 5.77614 12.7761 6 12.5 6H11.5C11.2239 6 11 5.77614 11 5.5V3C11 2.44772 10.5523 2 10 2H9.5"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M5 9.5H3C2.44772 9.5 2 9.94772 2 10.5V14.5C2 15.0523 2.44772 15.5 3 15.5H5"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <rect
        x="5"
        y="5"
        width="14"
        height="14"
        rx="2"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
  </g>
</template>
